// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { qtyFieldStyles } from "@awc/App/Components/Qty/QtyField";
import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { css } from "styled-components";

qtyFieldStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        position: relative;
        max-width: 50px;
        ${({ labelOnLeft }: any) =>
            labelOnLeft &&
            css`
                display: inline-block;
            `}
    `,
};
qtyFieldStyles.editableQuantityTextField = {
    mergeCss: true,
    labelProps: {
        css: css`
            display: none;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            &&&& {
                margin-top: 0;
            }
        `,
        inputSelect: css`
            text-align: left;
        `,
    },
};

qtyFieldStyles.valueText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text,
};

qtyFieldStyles.qtyLabel = {
    ...cartLineSharedStyles.qtyLabel,
};
